import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Heart, Users, Award, Lock, CheckCircle } from 'lucide-react';

interface TrustBadge {
  icon: React.ComponentType<any>;
  title: string;
  description: string;
  color: string;
}

const trustBadges: TrustBadge[] = [
  {
    icon: Shield,
    title: "Privacy Protected",
    description: "Your data is encrypted and secure",
    color: "from-emerald-400 to-teal-500"
  },
  {
    icon: Heart,
    title: "Women-Centered",
    description: "Designed by women, for women",
    color: "from-pink-400 to-rose-500"
  },
  {
    icon: Users,
    title: "Community Trusted",
    description: "Join 50,000+ women worldwide",
    color: "from-purple-400 to-indigo-500"
  },
  {
    icon: Award,
    title: "Medically Reviewed",
    description: "Approved by healthcare professionals",
    color: "from-blue-400 to-cyan-500"
  }
];

const TrustBadges: React.FC = () => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 py-8">
      {trustBadges.map((badge, index) => (
        <motion.div
          key={badge.title}
          className="text-center p-4 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/30 hover:bg-white/80 transition-all duration-300"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ y: -5, scale: 1.02 }}
        >
          <motion.div
            className={`w-12 h-12 mx-auto mb-3 bg-gradient-to-br ${badge.color} rounded-full flex items-center justify-center`}
            whileHover={{ rotate: 10, scale: 1.1 }}
          >
            <badge.icon className="w-6 h-6 text-white" />
          </motion.div>
          <h3 className="font-semibold text-gray-900 text-sm mb-1">{badge.title}</h3>
          <p className="text-xs text-gray-600 leading-relaxed">{badge.description}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default TrustBadges;